import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Ad } from 'app/shared/models/pub/pub';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdsService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getAdRandom(): Observable<Ad> {
    return this.http.get<Ad>(`${environment.apiUrl}/Pubs/pub`);
  }


}
